"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _Title = _interopRequireDefault(require("../Title"));

var _Paragraph = _interopRequireDefault(require("../Paragraph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventDetails = function EventDetails(_ref) {
  var title = _ref.title,
      dateString = _ref.dateString,
      contact = _ref.contact,
      contactLink = _ref.contactLink,
      subject = _ref.subject;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "event-details"
  }, /*#__PURE__*/_react.default.createElement(_Title.default, {
    type: 4
  }, title), /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
    type: "secondary",
    dangerouslySetInnerHTML: {
      __html: dateString
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-info"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: contactLink,
    className: "text-underlined"
  }, contact)), subject && /*#__PURE__*/_react.default.createElement(_Paragraph.default, null, subject));
};

EventDetails.propTypes = {
  title: _propTypes.default.string.isRequired,
  dateString: _propTypes.default.string.isRequired,
  contact: _propTypes.default.string,
  contactLink: _propTypes.default.string,
  subject: _propTypes.default.string
};
EventDetails.defaultProps = {
  contact: '',
  contactLink: '',
  subject: ''
};
var _default = EventDetails;
exports.default = _default;